import { IconButton, Menu, MenuItem } from "@mui/material";
import i18next from "i18next";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../store/UI";
import { StoreInterfaces } from "../../types/store";
import { useUserPreferences } from "../../hooks/Preferences/useUserPreferences";
import { UserPreferences } from "../../types/ui";

const LANGUAGES = [
  { code: "en", label: "English", flag: "/flags/gb.png" },
  { code: "pt", label: "Português", flag: "/flags/pt.png" },
  { code: "es", label: "Español", flag: "/flags/es.png" },
];

const LanguageSelector = () => {
  const dispatch = useDispatch();
  const currentLanguage = useSelector(
    (state: StoreInterfaces) => state.ui.language,
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { preferences, updatePreferences } = useUserPreferences();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (language: string) => {
    dispatch(setLanguage(language));
    i18next.changeLanguage(language);
    updatePreferences({ ...preferences, language: language as UserPreferences["language"] });
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick} color="inherit">
        <img
          src={
            LANGUAGES.find((lang) => lang.code === currentLanguage)?.flag ||
            "/flags/pt.png"
          }
          alt="Current Language"
          width="24"
          height="16"
        />
      </IconButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
          >
            <img
              src={lang.flag}
              alt={lang.label}
              width="24"
              height="16"
              style={{ marginRight: "10px" }}
            />
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
